export default __webpack_public_path__ + "static/media/header_menu.3aef3d23.less";